var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"html-content",staticStyle:{"min-height":"660px"}},[(_vm.data)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}}):_c('div',{staticClass:"null-data df fdc jcc aic"},[_c('img',{attrs:{"src":require("@/assets/images/empty_data.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('暂无资料')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }